var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('h1',[_vm._v("Page Not Found.")]),_c('br'),_c('p',[_c('v-btn',{staticClass:"text2",attrs:{"color":"#272727","label":"","dark":"","large":"","to":{ path: '/' }}},[_vm._v(" Return Home ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }